import { PUBLIC_GTM_ID } from '@shared-submodule/sm-constants'

export const GTM_ID = PUBLIC_GTM_ID

export const tagPageview = (url) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'page_view',
      page_path: url,
      page_title: document.title,
      page_location: window.location.href
    })
  }
}

export const tagEvent = ({ event, category, action, label, value }) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: event || 'custom_event',
      event_category: category,
      event_action: action,
      event_label: label,
      event_value: value
    })
  }
}
